const LeadDataContainer = ({ text, number }) => {
  return (
    <div 
      className="flex flex-col text-center h-[8.5rem] w-full bg-white 
                 p-4 mb-2"
      style={{ minWidth: "135x" }}   // Controlled min-width
    >
      <p className="head-2 dark-H flex items-center justify-center pb-2 mt-3 text-[22px] font-semibold">
        {number}
      </p>
      <p className="body-S dark-M text-[13px] leading-tight px-1 line-clamp-2">
        {text}
      </p>
    </div>
  );
};
 
export default LeadDataContainer;